const API_URL_MAP = {
  LOGS: '/api/logs',
  OAUTH: '/oauth',
  USERS: '/api/users',
  COUNT_USERS: '/api/users/count',
  REGISTRATION: '/register-or-verify/',
  USERS_ME: '/api/users/me',
  USERS_PUBLIC_V2: '/api/users/public',
  RESTORE_PASSWORD: '/api/users/forgot',
  RESET_PASSWORD: '/api/users/reset',
  LOGOUT: '/api/users/logout',
  UPDATE_USER_AVATAR: '/api/users/me/avatar',
  VERIFY_EMAIL: '/api/users/verify-email/',
  FILES: '/api/files',
  INSERT: '/insert',
  INSERT_INTERNAL_VIDEO: '/insert-internal-video',
  VIDEO_RECORDS: '/api/records',
  CHANGE_PASSWORD: '/api/users/me/change-password',
  GET_CONTACTS: '/api/users/me/contacts',
  GET_FAVORITE_CONTACTS: '/api/users/me/favorite-contacts',
  GET_RECENT_CONTACTS: '/api/users/me/recent-contacts',
  VIDEOSESSION: '/api/videosessions',
  VIDEOPOLLS: '/api/video-polls',
  VIDEOPOLL_TEMPLATES: '/api/video-poll-templates',
  DEFAULT_VIDEOPOLL_TEMPLATES: '/api/default-video-poll-templates',
  CANDIDATE_VIDEO_POLLS: '/api/candidate-video-polls',
  INVITE_EMAIL: '/invite/email',
  INVITE_ONLINE: '/invite/socket',
  UNLOCK_USER: '/unlock',
  BAN_USER: '/ban',
  PUBLIC: '/public',
  CONTACTS: '/contacts',
  FAVORITE_CONTACTS: '/favorite-contacts',
  OPEN: '/open',
  CLOSE: '/close',
  CHECK_AVAILABILITY: '/check-availability',
  CHECK_AVAILABLE: '/check-available',
  SUPPORTS: '/api/supports',
  ATTACHED_FILE: '/attached-file',
  INVITE_ACCEPT: '/invite/accept',
  INVITE_DECLINE: '/invite/decline',
  INVITE_CANCEL: '/invite/cancel',
  INSTRUCTIONS: '/api/instructions',
  SUBSCRIBE_NEWS: '/subscribe-news',
  EMPLOYER_SUBSCRIBE_NEWS: '/employer-subscribe-news',
  SN_AUTH: '/snAuth',
  LINKED_ACCOUNT: '/linked-accounts',
  TARIFFS: '/api/tariffs',
  TARIFFS_OPTIONS: '/services-keys',
  PAY: '/pay',
  REQUEST_SET_CHECK: '/request-set-check',
  CACHE_PARES: '/cache-pares',
  SECURE_3D_CALLBACK: '/3d-secure-callback',
  RECORD_REQUEST: '/record-requests',
  ALLOW: '/allow',
  DECLINE: '/decline',
  NEWS: '/api/news',
  LIKE: '/liked',
  TRANSACTIONS: '/api/transactions',
  REFUND: '/refund',
  UPDATE_USER_SETTINGS: '/update-settings',
  UPDATE_DEVELOPER_SETTINGS: '/update-developer-settings',
  COMPANY_PICTURE: '/company-pic',
  RESUME_PICTURE: '/resume-pic',
  SHARE_PORTFOLIO: '/share-portfolio',
  LANDING: '/api/landing',
  PASSED_VIDEO_POLLS: '/api/passed-video-polls',
  SEND_TO_EMPLOYER: '/send-to-employer',
  POSTS: '/api/posts',
  HOT_VACANCIES: '/api/hot-vacancies',
  ONLINE_POLLS: '/api/online-polls',
  PASSED_ONLINE_POLLS: '/api/passed-online-polls',
  LANDING_REVIEWS: 'api/landing-reviews',
  PAID_SERVICES: '/api/paid-services',
  PERSONAL_TARIFFS: '/api/personal-tariffs',
  REFERENCE_BOOKS: '/api/reference-books',
  PROMO_CODES: '/api/promo-codes',
  REQUISITES: '/api/requisites',
  HOW_IT_WORK: '/api/how-it-works',
  REQUEST_INDIVIDUAL_TARIFF: '/api/paid-services/request-individual-tariff',
  LEGAL_DOCUMENTS: '/api/legal-documents',
  ABOUT_COMPANY: '/api/about-us',
  SOFTWARE_REQUIREMENTS: '/api/software-requirements',
  COMPANY_CONTACTS: '/api/company-contacts',
};

export default API_URL_MAP;
